
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyCombobox as SkyComboboxElement, SkyComboboxAddNewOptionDetail, SkyComboboxIconClickDetail, SkyComboboxSearchQueryChangedDetail, SkyComboboxValidationErrorDetail, SkyComboboxValidationSuccessDetail, SkyComboboxValueChangedDetail } from '@sky.ui/core/sky-combobox';
 
 

 
 export const SkyCombobox = createComponent({
   displayName: 'SkyCombobox',
   react: React,
   tagName: 'sky-combobox',
   elementClass: SkyComboboxElement,
   events: {
     
     onValueChanged: 'value-changed' as EventName<CustomEvent<SkyComboboxValueChangedDetail>>,
     onSearchQueryChanged: 'search-query-changed' as EventName<CustomEvent<SkyComboboxSearchQueryChangedDetail>>,
     onValidationError: 'validation-error' as EventName<CustomEvent<SkyComboboxValidationErrorDetail>>,
     onValidationSuccess: 'validation-success' as EventName<CustomEvent<SkyComboboxValidationSuccessDetail>>,
     onIconClick: 'icon-click' as EventName<CustomEvent<SkyComboboxIconClickDetail>>,
     onAddNewOption: 'add-new-option' as EventName<CustomEvent<SkyComboboxAddNewOptionDetail>>,
   }
  });
export type * from '@sky.ui/core/sky-combobox';
